<template>
  <v-card-text class="pa-2">
    <v-layout>
      <v-layout column>
        <span>
          <strong>
            {{ cart.account_name }}
          </strong>
        </span>
        <span>
          {{ cart.name }}
        </span>
      </v-layout>
      <v-layout 
        v-if="$vuetify.breakpoint.smAndUp" 
        column 
        class="text-xs-right">
        <span>
          {{ cart.code == '' ? 'Ei seurantakoodia' : 'Seurantakoodi' }}
        </span>
        <strong>
          {{ cart.code }}
        </strong>
      </v-layout>
    </v-layout>
    <span 
      v-if="$vuetify.breakpoint.xsOnly" 
      class="mobiletrackingcode">
      <span class="pa-0">
        {{ cart.code == '' ? 'Ei seurantakoodia' : 'Seurantakoodi: ' }}
      </span>
      <span>
        {{ cart.code }}
      </span>
    </span>
  </v-card-text>
</template>
<script>
export default {
	props: ['cart']
}
</script>
<style>
.mobiletrackingcode {
  font-family: monospace;
  padding: 2px 0px;
  color: #af3123;
  background-color: #f5f5f5;
  border-radius: 5px;
  display: inline-block;
}
</style>